import { AxiosError } from "axios";

export enum NetworkTypes {
  GET = "get",
  PUT = "put",
  POST = "post",
  PATCH = "patch",
  DELETE = "delete",
}
export interface ApiRequest {
  method?: NetworkTypes;
  data?: unknown;
  endPoint?: string;
  baseUrl?: string;
}

export interface CustomError {
  request: ApiRequest;
  response: unknown;
  title?: string;
  details?: string;
}

export interface BookingValidationErrorFromAPI {
  // bookingId: number;
  validation: string[];
  title?: string;
  details?: string;
}

export function handleAndThrowError(
  error: unknown,
  request: ApiRequest
): CustomError {
  if (error instanceof AxiosError) {
    if (error.response) {
      if (
        error.response.data !== "" &&
        error.response.data !== null &&
        error.response.data !== undefined
      ) {
        throw {
          response: error.response.data,
          request: request,
        } as CustomError;
      } else {
        throw {
          response: error.message,
          request: request,
        };
      }
    }
  }
  throw {
    response: error,
    request: request,
  } as CustomError;
}
